import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/ShopsStyles.css';

const WholesalePageRedesign = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [isMobile, setIsMobile] = useState(false);
  const [isWholesaleCustomer, setIsWholesaleCustomer] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 700);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Promo Banner (reuse from About page)
  const PromoBanner = () => (
    <div style={{
      background: '#f8f8f8',
      borderBottom: '1px solid #e8e8e8',
      padding: '12px 24px',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px'
      }}>
        <div style={{
          width: '40px',
          height: '1px',
          background: '#ddd'
        }} />
        <span style={{
          fontSize: '13px',
          fontWeight: '500',
          color: '#333',
          textTransform: 'uppercase',
          letterSpacing: '1.5px',
          fontFamily: 'inherit'
        }}>
          Free Delivery on Orders Above QAR 100
        </span>
        <div style={{
          width: '40px',
          height: '1px',
          background: '#ddd'
        }} />
      </div>
    </div>
  );

  return (
    <div className="grey-bg-background">
      <div className="main-content-frame" style={{ 
        overflowX: 'hidden', 
        width: '100%', 
        maxWidth: '100vw' 
      }}>
        <div className="main-content-overlay"></div>
        <Header />
        
        {/* Hero Section */}
        <section
          style={{
            width: '100%',
            maxWidth: isMobile ? '100vw' : 1400,
            margin: '0 auto',
            padding: isMobile ? '0 20px 32px 20px' : '0 40px 64px 40px',
            textAlign: 'center',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              marginTop: 48,
              marginBottom: 32,
              width: '100%',
              maxWidth: 1100,
              marginLeft: 'auto',
              marginRight: 'auto',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <img
              src="/images/biglogo.png"
              alt="GREY"
              style={{
                height: isMobile ? 80 : 120,
                width: 'auto',
                display: 'block',
                margin: '0 18px',
                objectFit: 'contain',
              }}
            />
          </div>
          
          <div
            style={{
              fontFamily: 'Inter, Arial, sans-serif',
              fontSize: isMobile ? 28 : 42,
              fontWeight: 700,
              color: '#222',
              margin: '0 auto 24px auto',
              maxWidth: isMobile ? '100%' : 800,
              textAlign: 'center',
              letterSpacing: '2px',
              textTransform: 'uppercase'
            }}
          >
            WHOLESALE PARTNERSHIP
          </div>
          
          <div
            style={{
              fontFamily: 'Georgia, serif',
              fontSize: isMobile ? 16 : 18,
              color: '#666',
              margin: '0 auto 32px auto',
              maxWidth: isMobile ? '100%' : 700,
              lineHeight: 1.6,
              textAlign: 'center',
              padding: '0',
              boxSizing: 'border-box',
            }}
          >
            Premium coffee solutions for your business. Join us in crafting exceptional coffee experiences.
          </div>
          
          <div
            style={{
              width: isMobile ? '80%' : '60%',
              margin: '0 auto 32px auto',
              borderBottom: '1px solid #222',
              height: 0,
            }}
          />
          
          {isWholesaleCustomer ? (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 24,
              alignItems: 'center'
            }}>
              <div style={{
                fontFamily: 'Inter, Arial, sans-serif',
                fontSize: 16,
                color: '#666',
                textAlign: 'center',
                maxWidth: 600,
                lineHeight: 1.6
              }}>
                Welcome back! Access your wholesale dashboard to manage orders, view invoices, and more.
              </div>
              <button
                onClick={() => navigate('/wholesale-login')}
                style={{
                  background: '#222',
                  color: '#fff',
                  border: 'none',
                  padding: isMobile ? '14px 24px' : '16px 32px',
                  fontSize: isMobile ? 12 : 14,
                  fontWeight: 700,
                  fontFamily: 'Inter, Arial, sans-serif',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  borderRadius: 0
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#000';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#222';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                ACCESS YOUR DASHBOARD
              </button>
            </div>
          ) : (
            <button
              onClick={() => navigate('/wholesale-application')}
              style={{
                background: '#222',
                color: '#fff',
                border: 'none',
                padding: isMobile ? '14px 24px' : '16px 32px',
                fontSize: isMobile ? 12 : 14,
                fontWeight: 700,
                fontFamily: 'Inter, Arial, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                borderRadius: 0
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#000';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#222';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              APPLY FOR WHOLESALE ACCOUNT
            </button>
          )}
        </section>

        {/* Benefits Section */}
        <section
          style={{
            width: '100%',
            maxWidth: isMobile ? '100vw' : 1400,
            margin: '0 auto',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'center',
            alignItems: 'stretch',
            gap: isMobile ? 24 : 32,
            marginBottom: isMobile ? 32 : 64,
            padding: isMobile ? '0 20px' : '0 40px',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              flex: isMobile ? 'none' : '1 1 0',
              width: isMobile ? '100%' : 'auto',
              background: '#fff',
              border: '1px solid #ececec',
              borderRadius: 0,
              boxShadow: 'none',
              padding: isMobile ? '24px 20px' : '40px 24px',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: isMobile ? 'auto' : '200px',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.1)';
              e.currentTarget.style.borderColor = '#222';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.borderColor = '#ececec';
            }}
          >
            <div
              style={{
                fontFamily: 'Inter, Arial, sans-serif',
                fontWeight: 700,
                fontSize: isMobile ? 18 : 22,
                letterSpacing: 1,
                marginBottom: 16,
                textAlign: 'center',
                color: '#222',
                textTransform: 'uppercase'
              }}
            >
              PREMIUM QUALITY
            </div>
            <div
              style={{
                fontFamily: 'Inter, Arial, sans-serif',
                fontSize: isMobile ? 14 : 16,
                color: '#666',
                lineHeight: 1.6,
                textAlign: 'center',
              }}
            >
              Expertly sourced and roasted beans for consistent quality in every cup
            </div>
          </div>

          <div
            style={{
              flex: isMobile ? 'none' : '1 1 0',
              width: isMobile ? '100%' : 'auto',
              background: '#fff',
              border: '1px solid #ececec',
              borderRadius: 0,
              boxShadow: 'none',
              padding: isMobile ? '24px 20px' : '40px 24px',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: isMobile ? 'auto' : '200px',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.1)';
              e.currentTarget.style.borderColor = '#222';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.borderColor = '#ececec';
            }}
          >
            <div
              style={{
                fontFamily: 'Inter, Arial, sans-serif',
                fontWeight: 700,
                fontSize: isMobile ? 18 : 22,
                letterSpacing: 1,
                marginBottom: 16,
                textAlign: 'center',
                color: '#222',
                textTransform: 'uppercase'
              }}
            >
              DEDICATED SUPPORT
            </div>
            <div
              style={{
                fontFamily: 'Inter, Arial, sans-serif',
                fontSize: isMobile ? 14 : 16,
                color: '#666',
                lineHeight: 1.6,
                textAlign: 'center',
              }}
            >
              Personal account manager and training for your team
            </div>
          </div>

          <div
            style={{
              flex: isMobile ? 'none' : '1 1 0',
              width: isMobile ? '100%' : 'auto',
              background: '#fff',
              border: '1px solid #ececec',
              borderRadius: 0,
              boxShadow: 'none',
              padding: isMobile ? '24px 20px' : '40px 24px',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: isMobile ? 'auto' : '200px',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.1)';
              e.currentTarget.style.borderColor = '#222';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.borderColor = '#ececec';
            }}
          >
            <div
              style={{
                fontFamily: 'Inter, Arial, sans-serif',
                fontWeight: 700,
                fontSize: isMobile ? 18 : 22,
                letterSpacing: 1,
                marginBottom: 16,
                textAlign: 'center',
                color: '#222',
                textTransform: 'uppercase'
              }}
            >
              CUSTOM SOLUTIONS
            </div>
            <div
              style={{
                fontFamily: 'Inter, Arial, sans-serif',
                fontSize: isMobile ? 14 : 16,
                color: '#666',
                lineHeight: 1.6,
                textAlign: 'center',
              }}
            >
              Tailored coffee programs and equipment solutions
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section
          style={{
            width: '100%',
            maxWidth: isMobile ? '100vw' : 1400,
            margin: '0 auto',
            padding: isMobile ? '0 20px 32px 20px' : '0 40px 64px 40px',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              fontFamily: 'Inter, Arial, sans-serif',
              fontSize: isMobile ? 24 : 32,
              fontWeight: 700,
              color: '#222',
              textAlign: 'center',
              marginBottom: isMobile ? 24 : 32,
              letterSpacing: '1px',
              textTransform: 'uppercase'
            }}
          >
            OUR SERVICES
          </div>
          
          <div
            style={{
              width: isMobile ? '80%' : '60%',
              margin: '0 auto 32px auto',
              borderBottom: '1px solid #222',
              height: 0,
            }}
          />

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
            gap: isMobile ? 16 : 24,
            maxWidth: 1000,
            margin: '0 auto',
            justifyItems: 'stretch',
            alignItems: 'stretch'
          }}>
            {[
              'Custom roasting profiles tailored to your brand',
              'Equipment leasing and maintenance programs',
              'Comprehensive barista training workshops',
              'Marketing support and promotional materials',
              'Regular quality control visits and consultations',
              'Flexible ordering system with bulk discounts'
            ].map((service, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  padding: isMobile ? '16px 12px' : '20px 16px',
                  background: '#fff',
                  border: '1px solid #ececec',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  width: '100%',
                  boxSizing: 'border-box',
                  justifyContent: 'flex-start',
                  textAlign: 'left',
                  minHeight: '60px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#f8f8f8';
                  e.currentTarget.style.borderColor = '#222';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#fff';
                  e.currentTarget.style.borderColor = '#ececec';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div style={{
                  fontFamily: 'Georgia, serif',
                  fontSize: 16,
                  fontWeight: 700,
                  color: '#222',
                  flexShrink: 0,
                  marginTop: 2
                }}>•</div>
                <div style={{
                  fontFamily: 'Inter, Arial, sans-serif',
                  fontSize: isMobile ? 14 : 16,
                  color: '#666',
                  lineHeight: 1.6
                }}>{service}</div>
              </div>
            ))}
          </div>
        </section>


        <Footer />
      </div>
    </div>
  );
};

export default WholesalePageRedesign;